import * as firebase from 'firebase';

const config = {
    apiKey: "AIzaSyCDr8XXqQsylJy7YLHKx68ZFNTOz3IKXWg",
    authDomain: "micreate-storytelling.firebaseapp.com",
    databaseURL: "https://micreate-storytelling.firebaseio.com",
    projectId: "micreate-storytelling",
    storageBucket: "micreate-storytelling.appspot.com",
    messagingSenderId: "1086625356319",
    appId: "1:1086625356319:web:47e0a317bdd6b29c"
};

firebase.initializeApp(config);

export default firebase
export const auth = firebase.auth();

export const database = firebase.firestore();
database.settings({
    cacheSizeBytes: firebase.firestore.CACHE_SIZE_UNLIMITED,
});

database.enablePersistence().catch(function(err) {
    console.log('error enabling persistance ' + err);
});

export const dbShared = database.collection('shared');
export const dbStories = database.collection('stories');
export const dbPages = database.collection('pages');
export const dbPlacedItems = database.collection('placed_items');
export const getOpts = {
    source: 'cache'
};